{
  "manual": {
    "button": "Manual",
    "title": "Portal manual",
    "loading": "Loading video…"
  }
}
